export default "/directory/static/discount_days.c5b430b6.svg";